export default __webpack_public_path__ + "static/media/B0001.51bded3d.png";